module.exports = __webpack_public_path__ + "static/media/slide1.99f5a28e.jpg";